<template>
  <div id="st-content-graphic" class="st-content-graphic scroll-content" itemscope itemtype="http://schema.org/NewsArticle">
    <meta itemprop="datePublished" v-if="date" :content="date" />
    <st-menu></st-menu>
    <!-- route outlet -->
    <!-- component matched by the route will render here -->
    <transition>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
    <st-footer ref="footer"></st-footer>
    <transition name="fade">
      <st-loading v-if="$loading.isLoading" />
    </transition>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import StMenu from './menu/index.vue'
import StFooter from './footer/index.vue'
import StLoading from './StLoading.vue'

export default {
  components: {StMenu, StFooter, StLoading},
  computed: mapState(['date'])
}
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 1s;
}

.fade-leave-to {
  opacity: 0;
}
</style>
